(function () {
    document.addEventListener("DOMContentLoaded", (event) => {
        let dcModules = document.querySelectorAll(".downloadable-content-module");

        Array.prototype.forEach.call(dcModules, () => {
            let loadMoreBtn = document.querySelector(".downloadable-content-loadmore-btn");

            if (loadMoreBtn) {
                loadMoreBtn.addEventListener("click", () => {
                    downloadableContent.loadMore(loadMoreBtn);
                });
            } 
        });
    });

    const downloadableContent = {
        data: {
            rowsShown: 1
        },
        loadMore: function (btn) {
            this.data.rowsShown++;

            let rows = document.querySelectorAll(".downloadable-content-module .row");
            let rowsToShow = Array.prototype.slice.call(rows, 0, this.data.rowsShown);

            Array.prototype.forEach.call(rowsToShow, (row) => {
                row.classList.remove("is-d-none");
            });
  
            if (rowsToShow.length === rows.length) {
                btn.classList.add("is-d-none");
            }
        }
    }
})();